/** @format */

export const CONSTANTS_ASSETS_EMP_WEB_EXP = {
  IMAGES: {
    EMPTY_HERO: "assets/libraries/mis-employee-web-exp/images/empty-booking-card.svg",
    MOBILE_EMPTY_HERO: "assets/libraries/mis-employee-web-exp/images/mobile-empty-booking-card.png",
    NO_UPCOMING: "assets/libraries/mis-employee-web-exp/images/upcoming-bookings.svg",
    HERO_BG: "assets/libraries/mis-employee-web-exp/images/hero-BG.svg",
    EMPTY_PLATE: "assets/libraries/mis-employee-web-exp/images/empty-plate.svg",
    PARKING_BG: "assets/libraries/mis-employee-web-exp/images/parking-bg.svg",
    CERTIFICATE: "assets/libraries/mis-employee-web-exp/images/certificate.svg",
    BOOKING_SUCCESS: "assets/libraries/mis-employee-web-exp/images/booking-success.svg",
    HISTORY_EMPTY: "assets/libraries/mis-employee-web-exp/images/history-empty-state.svg"
  },
  ICONS: {
    MORE: "assets/libraries/mis-employee-web-exp/icons/ic-action-more-vert.svg",
    CANCELLED: "assets/libraries/mis-employee-web-exp/icons/ic-nav-cancelled-24.svg",
    CANCEL_INFO: "assets/libraries/mis-employee-web-exp/icons/ic-ui-cancel-info-24.svg",
    DOWN_ARROW: "assets/libraries/mis-employee-web-exp/icons/down-arrow.svg",
    HERO_RIGHT: "assets/libraries/mis-employee-web-exp/icons/ic-navigation-chevron-right-blue-24.svg",
    SEAT: "assets/libraries/mis-employee-web-exp/icons/seat.svg",
    CLOSE: "assets/libraries/mis-employee-web-exp/icons/close-popup.svg",
    CALENDAR: "assets/libraries/mis-employee-web-exp/icons/ic-rep-calendar.svg",
    CAB: "assets/libraries/mis-employee-web-exp/icons/ic-ui-car-24.svg",
    CAB_DARK: "assets/libraries/mis-employee-web-exp/icons/ic-ui-transport-black-24.svg",
    TICK_GREEN: "assets/libraries/mis-employee-web-exp/icons/ic-tick-green.svg",
    SUCCESS_TICK: "assets/libraries/mis-employee-web-exp/icons/ic-ui-success-24.svg",
    ARROW: "assets/libraries/mis-employee-web-exp/icons/arrow.svg",
    EDIT: "assets/libraries/mis-employee-web-exp/icons/ic-action-edit-16.svg",
    EDIT_DARK: "assets/libraries/mis-employee-web-exp/icons/edit_dark.svg",
    CANCEL: "assets/libraries/mis-employee-web-exp/icons/Union.svg",
    IC_RADIO: "assets/libraries/mis-employee-web-exp/icons/ic-selection-radio.svg",
    IC_RADIO_ACTIVE: "assets/libraries/mis-employee-web-exp/icons/ic-selection-radio-active.svg",
    IC_ADD: "assets/libraries/mis-employee-web-exp/icons/ic-action-add-24.svg",
    IC_CLOSE: "assets/libraries/mis-employee-web-exp/icons/ic-navigation-cancel-24.svg",
    IC_WFO: "assets/libraries/mis-employee-web-exp/icons/ic-nav-office-24.svg",
    IC_WFH: "assets/libraries/mis-employee-web-exp/icons/ic-sidebar-home-24.svg",
    DESK: "assets/libraries/mis-employee-web-exp/icons/ic-nav-desk-mgmt-24.svg",
    DESK_BULE: "assets/libraries/mis-employee-web-exp/icons/desk.svg",
    DESK_GREY: "assets/libraries/mis-employee-web-exp/icons/ic-nav-desk-mgmt-grey-24.svg",
    CHEVRON_RIGHT: "assets/libraries/mis-employee-web-exp/icons/ic-navigation-chevron-right-24.svg",
    CANCEL_BIN: "assets/libraries/mis-employee-web-exp/icons/cancelbin.svg",
    WFH: "assets/libraries/mis-employee-web-exp/icons/wfh.svg",
    WFO_CONVERT: "assets/libraries/mis-employee-web-exp/icons/ic-convert-WFO-24.svg",
    WFH_CONVERT: "assets/libraries/mis-employee-web-exp/icons/convert-booking-wfo.svg",
    WFO_CONVERT_DARK: "assets/libraries/mis-employee-web-exp/icons/ic-convert-WFO-24.svg",
    WFH_CONVERT_DARK: "assets/libraries/mis-employee-web-exp/icons/convert-booking-wfo-dark.svg",
    QUICK_WFH: "assets/libraries/mis-employee-web-exp/icons/quick-wfh.svg",
    QUICK_WFO: "assets/libraries/mis-employee-web-exp/icons/quick-wfo.svg",
    CLOCK: "assets/libraries/mis-employee-web-exp/icons/ic-action-shift time-24.svg",
    PARKING: "assets/libraries/mis-employee-web-exp/icons/ic-ui-parking-24-blue.svg",
    PARKING_ACTIVE: "assets/libraries/mis-employee-web-exp/icons/ic-ui-parking-24-white.svg",
    TRANSPORT: "assets/libraries/mis-employee-web-exp/icons/ic-ui-transport-24-blue.svg",
    TRANSPORT_ACTIVE: "assets/libraries/mis-employee-web-exp/icons/ic-ui-transport-24-white.svg",
    TRANSPORT_UNAVAILABILTY: "assets/libraries/mis-employee-web-exp/icons/ic-new-icon-transport-availibilty.svg",
    TRANSPORT_AVAILABILTY: "assets/libraries/mis-employee-web-exp/icons/ic-new-icon-transport-Availibilty-V1-32.svg",
    INFO: "assets/libraries/mis-employee-web-exp/icons/ic-ui-info-24.svg",
    CHOICE_CHIP: "assets/libraries/mis-employee-web-exp/icons/ic-ui-check-24.svg",
    MEAL: "assets/libraries/mis-employee-web-exp/icons/ic-ui-meal-24.svg",
    MEAL_DARK: "assets/libraries/mis-employee-web-exp/icons/ic-ui-meal-24-dark.svg",
    MEAL_CHECK: "assets/libraries/mis-employee-web-exp/icons/ic-ui-check-24.svg",
    AVATAR: "assets/libraries/mis-employee-web-exp/icons/avatar.svg",
    PARKING_MODULE: "assets/libraries/mis-employee-web-exp/icons/ic-ui-hero-parking-24.svg",
    APPROVAL_STATUS: "assets/libraries/mis-employee-web-exp/icons/ic-ui-approval-info-24.svg",
    SUCCESS_RECURRENCE: "assets/libraries/mis-employee-web-exp/icons/ic-ui-approvals2-24.svg",
    FAILED_BOOKINGS: "assets/libraries/mis-employee-web-exp/icons/ic-ui-cross-24.svg",
    MORE_STATUS: "assets/libraries/mis-employee-web-exp/icons/status-navigation.svg"
  }
};
